import React, { useState } from "react";
 
const UrlEnDecode = () => {
    // State variables for component
    const [isEncoderVisible, setEncoderVisible] = useState(true);
    const [text, setText] = useState("");
    const [output, setOutput] = useState("");
  
    // Handler for switching to encoder section
    const encoderButton = () => {
      setEncoderVisible(true);
      setText(""); // Clear the text field when switching to the encoder section
      setOutput(""); // Clear the output field
    };
  
    // Handler for switching to decoder section
    const decoderButton = () => {
      setEncoderVisible(false);
      setText(""); // Clear the text field when switching to the decoder section
      setOutput(""); // Clear the output field
    };
  
    // Handler for URL encoding logic
    const handleFormatButtonClick = () => {
      // URL encoding logic should be implemented here
      encodeUri(); // Use the function for encoding
    };
  
    // Handler for resetting input and output fields
    const handleResetButtonClick = () => {
      setText("");
      setOutput("");
    };
  
    // Function to perform URL encoding
    const encodeUri = () => setOutput(encodeURIComponent(text));
  
    // Function to perform URL decoding
    const decodeUri = () => setOutput(decodeURIComponent(text));
  
    return (
        <main>
            <div className="container mt-4">
                {/* Header section */}
                <div className="d-flex justify-content-between">
                    <h2>URL En/Decoder</h2>
                    <nav aria-label="Page navigation">
                        <ul className="pagination">
                            <li
                                type="button"
                                className="page-item border p-2 roundedBtnLeft"
                                onClick={encoderButton}
                            >
                                Encoder
                            </li>
                            <li
                                type="button"
                                className="page-item border p-2 roundedBtnRight"
                                onClick={decoderButton}
                            >
                                Decoder
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Encoder/Decoder sections */}
                {isEncoderVisible ? (
                    <section aria-labelledby="encoder-heading">
                        <h4 id="encoder-heading" className="mt-3">Encoder</h4>
                        <textarea
                            className="form-control w-75"
                            value={text}
                            aria-label="Encoder Input"
                            onChange={(e) => setText(e.target.value)}
                            cols="5"
                            rows="5"
                        ></textarea>
                        <button
                            type="button"
                            className="btn btn-secondary mt-2"
                            onClick={handleFormatButtonClick}
                        >
                            Encode
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary mt-2 ms-2"
                            onClick={handleResetButtonClick}
                        >
                            Reset
                        </button>
                        <h4 className="mt-3">Encoded String</h4>
                        <textarea
                            className="form-control w-75"
                            value={output}
                            aria-label="Encoder Output"
                            id="output"
                            cols="5"
                            rows="5"
                            readOnly
                        ></textarea>
                    </section>
                ) : (
                    <section aria-labelledby="decoder-heading">
                        <h4 id="decoder-heading" className="mt-3">Decoder</h4>
                        <textarea
                            className="form-control w-75"
                            value={text}
                            aria-label="Decoder Input"
                            onChange={(e) => setText(e.target.value)}
                            rows="5"
                        ></textarea>
                        <button
                            type="button"
                            className="btn btn-secondary mt-2"
                            onClick={decodeUri}
                        >
                            Decode
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary mt-2 ms-2"
                            onClick={handleResetButtonClick}
                        >
                            Reset
                        </button>
                        <h4 className="mt-3">Decoded String</h4>
                        <textarea
                            className="form-control w-75"
                            value={output}
                            aria-label="Decoder Output"
                            id="output"
                            rows="5"
                            readOnly
                        ></textarea>
                    </section>
                )}
            </div>
        </main>
    );
};

export default UrlEnDecode;